import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {translate} from 'views/module';

import ViewEditBio from 'views/scenes/caregiver/detail/caregiver_scenes/caregiver_feed/biography/view_edit/ViewEditBio';
import Sections from 'views/scenes/caregiver/detail/caregiver_scenes/caregiver_feed/biography/sections';
import LoomContactView from './LoomContactView';

import {simplifyQuestions} from 'utils/user_bio';

// Loom has no CareOS route that changes a caregiver, so every section is view-only. The profile URL,
// agreement and user account sections of the legacy Biography tab stay out. The language section
// builds its recording links from the legacy RN, so a caregiver with none gets ''.
const SECTIONS = [
  {key: 'contact', title: 'caregiver.CaregiverBiography.Contact.Title', ViewComponent: LoomContactView},
  {key: 'profile', title: 'caregiver.CaregiverBiography.Profile.Title', ViewComponent: Sections.ProfileView},
  {key: 'languages', title: 'caregiver.CaregiverBiography.Languages.Title', ViewComponent: Sections.LanguagesView},
  {key: 'certificates', title: 'caregiver.CaregiverBiography.Certificate.Title', ViewComponent: Sections.CertificateView},
  {key: 'canadianId', title: 'caregiver.CaregiverBiography.CanadianId.Title', ViewComponent: Sections.CanadianIdView},
  {key: 'vulnerableSectorCheck', title: 'caregiver.CaregiverBiography.VulnerableSectorCheck.Title', ViewComponent: Sections.VulnerableSectorCheckView},
  {key: 'education', title: 'caregiver.CaregiverBiography.Education.Title', ViewComponent: Sections.EducationView},
  {key: 'workHistory', title: 'caregiver.CaregiverBiography.WorkHistory.Title', ViewComponent: Sections.WorkHistoryView},
  {key: 'references', title: 'caregiver.CaregiverBiography.References.Title', ViewComponent: Sections.ReferencesView},
  {key: 'prefsAndAvailability', title: 'caregiver.CaregiverBiography.PrefsAndAvailability.Title', ViewComponent: Sections.PrefsAndAvailabilityView},
  {key: 'skillsAndExp', title: 'caregiver.CaregiverBiography.SkillsAndExp.Title', ViewComponent: Sections.SkillsAndExpView},
  {key: 'personality', title: 'caregiver.CaregiverBiography.Personality.Title', ViewComponent: Sections.PersonalityView},
];

const noSave = () => undefined;

const LoomCaregiverProfile = (props) => {
  const {caregiver} = props;

  const bioQuestions = React.useMemo(() => {
    return simplifyQuestions(caregiver.caregiverBio?.questions || {});
  }, [caregiver]);

  return (
    <Stack
      spacing={2}
      sx={{
        margin: 1,
      }}
    >
      {
        SECTIONS.map((section) => (
          <ViewEditBio
            key={section.key}
            bioQuestions={bioQuestions}
            title={translate(section.title)}
            ViewComponent={section.ViewComponent}
            saveBioQuestions={noSave}
            editDisabled={true}
            caregiverRn={caregiver.caregiverRn || ''}
          />
        ))
      }
    </Stack>
  );
};
LoomCaregiverProfile.propTypes = {
  caregiver: PropTypes.object.isRequired,
};

export default React.memo(LoomCaregiverProfile);
